// src/components/PendenzResponsibleLinkModal.jsx
// Ordnet einen BESTEHENDEN CRM-Eintrag (Organisation/Person) dem aktuellen Projekt zu
// (kein neuer CRM-Eintrag). Erfasst nur die Projekt-Relation – mit Funktion und der
// Frage, ob die Verbindung öffentlich ist. project.code als SourceId (wie Netzwerk-Tab).
import React, { useState } from "react";
import {
  createRelation,
  RELATION_TYPES,
} from "../services/azureRelationsService";

const PendenzResponsibleLinkModal = ({
  option, // { id: "org:<id>" | "person:<id>", label, group }
  projectCode,
  // Optional: konkrete Rolle (z.B. RELATION_TYPES.AUFTRAGGEBERIN) statt der
  // generischen PROJECT_PARTNER/PROJECT_PERSON-Relation aus der Pendenzen-Nutzung.
  relationType,
  onClose,
  onLinked, // (relation) => void
}) => {
  const isOrg = option.id.startsWith("org:");
  const rawId = option.id.slice(option.id.indexOf(":") + 1);

  const [funktion, setFunktion] = useState("");
  // Organisationen sind standardmässig öffentlich, Personen privat (CRM-Konvention)
  const [oeffentlich, setOeffentlich] = useState(isOrg);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const handleSave = async (e) => {
    e.preventDefault();
    // Das Modal kann innerhalb eines anderen <form> geoeffnet sein (z.B.
    // ProjectForm via PartnerAssignField). React laesst submit im Komponenten-
    // baum weiter aufsteigen — ohne stopPropagation wuerde das aeussere
    // Formular ebenfalls abgeschickt (Projekt gespeichert, Ansicht neu geladen).
    e.stopPropagation();
    try {
      setSaving(true);
      setError(null);
      const relation = await createRelation({
        sourceType: "project",
        sourceId: projectCode,
        targetType: isOrg ? "partner" : "person",
        targetId: rawId,
        relationType:
          relationType ||
          (isOrg ? RELATION_TYPES.PROJECT_PARTNER : RELATION_TYPES.PROJECT_PERSON),
        function: funktion.trim(),
        description: `${isOrg ? "Organisation" : "Person"} in Projekt (über Pendenzen)`,
        visibility: oeffentlich,
      });
      onLinked(relation);
    } catch (err) {
      console.error("Verbindung zum Projekt fehlgeschlagen:", err);
      setError("Die Verbindung zum Projekt konnte nicht erfasst werden.");
      setSaving(false);
    }
  };

  // Weder Klick auf den Hintergrund noch Escape schliessen (Nutzerwunsch, ADR
  // 0060): kein versehentliches Verwerfen ungespeicherter Eingaben.
  return (
    <div
      className="pendenzen__modal-overlay"
      onKeyDown={(e) => {
        if (e.key === "Escape") e.stopPropagation();
      }}
    >
      <div
        className="pendenzen__modal pendenzen__modal--share"
        onClick={(e) => e.stopPropagation()}
      >
        <form onSubmit={handleSave}>
          <div className="pendenzen__modal-header">
            <h3>Dem Projekt zuordnen</h3>
            <button
              type="button"
              className="pendenzen__modal-close"
              onClick={onClose}
              aria-label="Schliessen"
            >
              ×
            </button>
          </div>

          <div className="pendenzen__modal-body">
            {error && (
              <div className="pendenzen__error" role="alert" onClick={() => setError(null)}>
                {error}
              </div>
            )}

            <p className="pendenzen__subtitle" style={{ marginBottom: "14px" }}>
              {isOrg ? "Organisation" : "Person"}:{" "}
              <strong>{option.label}</strong> wird dem Projekt zugeordnet. Es wird
              kein neuer CRM-Eintrag angelegt.
            </p>

            <div className="pendenzen__form-grid">
              <label className="pendenzen__field pendenzen__field--full">
                <span>Funktion im Projekt</span>
                <input
                  type="text"
                  value={funktion}
                  onChange={(e) => setFunktion(e.target.value)}
                  placeholder="z.B. Bauleitung"
                  autoFocus
                />
              </label>

              <label className="pendenzen__field pendenzen__field--checkbox pendenzen__field--full">
                <input
                  type="checkbox"
                  checked={oeffentlich}
                  onChange={(e) => setOeffentlich(e.target.checked)}
                />
                <span>Verbindung mit dem Projekt öffentlich sichtbar</span>
              </label>
            </div>
          </div>

          <div className="pendenzen__modal-footer">
            <div className="pendenzen__modal-footer-right">
              <button
                type="button"
                className="pendenzen__btn"
                onClick={onClose}
                disabled={saving}
              >
                Abbrechen
              </button>
              <button
                type="submit"
                className="pendenzen__btn pendenzen__btn--primary"
                disabled={saving}
              >
                {saving ? "Zuordnen..." : "Zuordnen"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PendenzResponsibleLinkModal;
